
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white rounded-t-[40px] mt-20">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:pr-8">
            <img
              src="https://static.readdy.ai/image/2063d56d77349d69e524f0264c628611/4414b4946d0eab3eabe73c49edc79181.jpeg"
              alt="Look Who's Moving"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm mb-6">
              Durban's most trusted bakkie removals and landscaping services across KwaZulu-Natal
            </p>
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full font-medium hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Quote
            </a>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/removals" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Bakkie Removals
                </Link>
              </li>
              <li>
                <Link to="/removals" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Furniture Transport
                </Link>
              </li>
              <li>
                <Link to="/removals" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Long-Distance Moves
                </Link>
              </li>
              <li>
                <Link to="/landscaping-services" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Landscaping Services
                </Link>
              </li>
              <li>
                <Link to="/landscaping-services" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Garden Clean-Ups
                </Link>
              </li>
              <li>
                <Link to="/landscaping-services" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Compost Delivery
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+27798768956"
                  className="text-gray-400 hover:text-primary transition-colors flex items-center cursor-pointer"
                >
                  <i className="ri-phone-line mr-3 w-5 h-5 flex items-center justify-center"></i>
                  079 876 8956
                </a>
              </li>
              <li>
                <a
                  href="mailto:bookings@lookwhosmoving.co.za"
                  className="text-gray-400 hover:text-primary transition-colors flex items-center cursor-pointer"
                >
                  <i className="ri-mail-line mr-3 w-5 h-5 flex items-center justify-center"></i>
                  bookings@lookwhosmoving.co.za
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/27798768956"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary transition-colors flex items-center cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-3 w-5 h-5 flex items-center justify-center"></i>
                  WhatsApp Us
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-gray-400">Pinetown, Durban, KwaZulu-Natal</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Service Areas</h4>
            <p className="text-gray-400 text-sm mb-4">
              We proudly serve all areas across KwaZulu-Natal including Durban, Pinetown, Westville, Hillcrest, Umlazi, and rural communities.
            </p>
            <Link to="/" className="text-primary hover:text-primary-light transition-colors cursor-pointer">
              View All Areas →
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Look Who's Moving. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            Pinetown, Durban, KZN
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 text-sm hover:text-primary transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
